import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["dateFieldName", "timeFieldName", "value", "onChange", "startWithNullDate", "disabled", "disableField", "margin", "xs", "md", "lg", "errorMessage", "shouldDisableDate", "variant", "noNameField"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useState } from 'react';
import { parseDate, PRINT_DATE_FORMAT, PRINT_DATE_TIME_FORMAT, printInputDate, printInputDateTime, printTime, roundToQuarter } from '@guryou/utils';
import { DateTimePicker as MuiDateTimePicker, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import PropTypes from 'prop-types';
import HiddenField from './HiddenField';
import { Block } from '../content';
const DateTimePicker = _ref => {
  let {
      dateFieldName,
      timeFieldName,
      value,
      onChange,
      startWithNullDate = false,
      disabled,
      disableField = false,
      margin = 'normal',
      xs,
      md,
      lg,
      errorMessage,
      shouldDisableDate,
      variant = 'inline',
      noNameField
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [localValue, setLocalValue] = useState(!value && startWithNullDate ? roundToQuarter(value, startWithNullDate) : parseDate(value, startWithNullDate));
  const triggerChangeForHiddenField = value => {
    if (!dateFieldName) {
      return;
    }
    const element = document.getElementById(dateFieldName);
    const lastValue = element.value;
    element.value = value;
    const tracker = element._valueTracker;
    if (tracker) {
      tracker.setValue(lastValue);
    }
    const event = new Event('input', {
      target: element,
      bubbles: true
    });
    element.dispatchEvent(event);
  };
  const onChangeHandler = date => {
    if (!date || !date._isAMomentObject || date.isValid()) {
      const val = printInputDateTime(date);
      setLocalValue(val);
      onChange && onChange(val);
      triggerChangeForHiddenField(val);
    }
  };
  let content = null;
  if (!xs && !md && !lg) {
    rest.margin = margin;
  }
  if (dateFieldName && timeFieldName) {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      id: dateFieldName,
      style: {
        display: 'none'
      },
      disabled: disabled,
      name: dateFieldName,
      value: printInputDate(localValue)
    }), /*#__PURE__*/React.createElement(HiddenField, {
      disabled: disabled,
      name: timeFieldName,
      value: printTime(localValue)
    }), /*#__PURE__*/React.createElement(MuiDateTimePicker, _extends({
      InputProps: {
        name: null
      },
      format: PRINT_DATE_TIME_FORMAT
    }, rest, {
      autoOk: true,
      variant: variant,
      value: localValue,
      onChange: onChangeHandler,
      helperText: errorMessage,
      error: !!errorMessage,
      shouldDisableDate: shouldDisableDate,
      orientation: "portrait"
    })));
  } else if (dateFieldName) {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      id: dateFieldName,
      style: {
        display: 'none'
      },
      disabled: disabled,
      name: dateFieldName,
      value: printInputDate(localValue)
    }), /*#__PURE__*/React.createElement(KeyboardDatePicker, _extends({}, rest, {
      InputProps: {
        name: null
      },
      format: PRINT_DATE_FORMAT,
      autoOk: true,
      variant: variant,
      value: localValue,
      onChange: onChangeHandler,
      helperText: errorMessage,
      error: !!errorMessage,
      disabled: disabled,
      shouldDisableDate: shouldDisableDate,
      orientation: "portrait"
    })));
  } else if (noNameField) {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      id: 'noNameField',
      style: {
        display: 'none'
      },
      disabled: disabled,
      value: printInputDate(localValue)
    }), /*#__PURE__*/React.createElement(KeyboardDatePicker, _extends({}, rest, {
      InputProps: {
        name: null
      },
      format: PRINT_DATE_FORMAT,
      autoOk: true,
      variant: variant,
      value: localValue,
      onChange: onChangeHandler,
      helperText: errorMessage,
      error: !!errorMessage,
      disabled: disabled,
      shouldDisableDate: shouldDisableDate,
      orientation: "portrait"
    })));
  } else if (noNameField) {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      id: 'noNameField',
      style: {
        display: 'none'
      },
      disabled: disabled,
      value: printInputDate(localValue)
    }), /*#__PURE__*/React.createElement(KeyboardDatePicker, _extends({}, rest, {
      InputProps: {
        name: null
      },
      format: PRINT_DATE_FORMAT,
      autoOk: true,
      variant: variant,
      value: localValue,
      onChange: onChangeHandler,
      helperText: errorMessage,
      error: !!errorMessage,
      disabled: disabled,
      shouldDisableDate: shouldDisableDate
    })));
  } else {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenField, {
      disabled: disabled,
      name: timeFieldName,
      value: printTime(localValue) || ''
    }), /*#__PURE__*/React.createElement(KeyboardTimePicker, _extends({}, rest, {
      InputProps: {
        name: null
      },
      autoOk: true,
      variant: variant,
      value: localValue,
      onChange: onChangeHandler,
      helperText: errorMessage,
      error: !!errorMessage,
      ampm: false,
      minutesStep: 5,
      disabled: disableField,
      shouldDisableDate: shouldDisableDate,
      orientation: "portrait"
    })));
  }
  if (xs || md || lg) {
    let marginProps;
    if (margin === 'normal') {
      marginProps = {
        margin: 4,
        marginBottom: 2
      };
    } else if (margin === 'none') {
      marginProps = {
        margin: 0
      };
    } else if (margin === 'wizard') {
      marginProps = {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 2,
        marginRight: 2
      };
    } else {
      marginProps = {
        margin
      };
    }
    return /*#__PURE__*/React.createElement(Block, _extends({
      xs: xs,
      md: md,
      lg: lg
    }, marginProps), content);
  }
  return content;
};
DateTimePicker.propTypes = {
  disablePast: PropTypes.bool,
  format: PropTypes.string,
  dateFieldName: PropTypes.string,
  timeFieldName: PropTypes.string
};
DateTimePicker.defaultProps = {
  disablePast: true,
  disabled: false
};
export default DateTimePicker;